export interface Serializer<T> {
  serialize(item: T): string;
  deserialize(value: string): T;
}

export const DateSerializer = {
  serialize: (item: Date): string => {
    const year = item.getFullYear();
    const month = item.getMonth() + 1;
    const dayOfMonth = item.getDate();
    const singleDigitThreshold = 10;

    const monthString = month < singleDigitThreshold ? `0${month}` : month;
    const dayOfMonthString =
      dayOfMonth < singleDigitThreshold ? `0${dayOfMonth}` : dayOfMonth;

    const dateString = `${year}-${monthString}-${dayOfMonthString}`;
    return dateString;
  },
  deserialize: (value: string): Date => {
    const sanitizedValue = value.replace(/-/g, '/');
    return new Date(sanitizedValue);
  },
};

export const BooleanSerializer = {
  serialize: (value: boolean): string => (value ? 'true' : 'false'),
  deserialize: (value: string): boolean => value.toLocaleLowerCase() === 'true',
};

export const IntSerializer = {
  serialize: (value: number): string => value.toString(),
  deserialize: (value: string): number => parseInt(value, 10),
};

export const DummySerializer = {
  serialize: (value: string): string => value,
  deserialize: (value: string): string => value,
};

export const IdentitySerializer = {
  serialize: (value: string): string => value,
  deserialize: (value: string): string => value,
};
